import React, {useEffect, useRef,useState } from "react"; 
import { Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import { getAssets,createGameQuestion,updateQuestion} from  "../../../Services/Games/gamesService" 
import {toast } from 'react-toastify';
import "../GlobalGames.css"
import Form from 'react-bootstrap/Form';
import PlaySound from "../PlaySound";
import {handleFileValidation} from "../../../utils/Api"
const CreateQuestion = ({ isShow,type,qusData,close,gameId,pageRerender }) => {   
  const [preview, setPreview] = useState(null);
  let[addQuestion,setAddQuestion]=useState(false)  
  let[uploadQuestion,setUploadQuestion]=useState(false)  
  let[asset,setAsset]=useState(null) 
  let game_id=gameId
  let[question,setQuestion]=useState('')
  let[option_a,setOptionA]=useState('')
  let[option_b,setOptionB]=useState('')
  let[option_c,setOptionC]=useState('')
  let[option_d,setOptionD]=useState('')
  let[correct_ans_sound,setCorrectAnsSound]=useState('')
  let[wrong_ans_sound,setWrongAnsSound]=useState('')
  let[correct_ans,setCorrectAns]=useState('')
  const [audio, setQuestionAudio] = useState(null);
  const [questionError, setQuestionError] = useState(false);
  const [option_aError, setOption_aError] = useState(false);
  const [option_bError, setOption_bError] = useState(false);
  const [option_cError, setOption_cError] = useState(false);
  const [option_dError, setOption_dError] = useState(false);
  const [correctAnsError, setCorrectAnsError] = useState(false);
  const [correctSoundError, setCorrectSoundError] = useState(false);
  const [wrongSoundError, setWrongSoundError] = useState(false);
  const [questionAudioError, setQuestionAudioError] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileError, setFileError] = useState(null);
  const [AssetError, setAssetError] = useState(false);
  const optionaRef = useRef(null);   
  const optionbRef = useRef(null);   
  const optioncRef = useRef(null);   
  const optiondRef = useRef(null);   
  const questionRef = useRef(null);    
  const handleClose = () => {setShow(false);close()};
  const [show, setShow] = useState(false); 
  const [isLoading, setIsloading] = useState(false);
  const [assetsData, setAssetsData] = useState([]);
    const handleSubmit = async (e) => {
      var error=false;
      if(type!='EDIT' && (!asset || !audio)){
        setAssetError(!asset)
        setQuestionAudioError(!audio)
        error=true;
      }
     if (!question.trim() || !option_a.trim() || !option_b.trim() || !option_c.trim()
      || !option_d.trim() || !correct_ans || !correct_ans_sound || !wrong_ans_sound) {
    setQuestionError(!question.trim());
    setOption_aError(!option_a.trim());
    setOption_bError(!option_b.trim());
    setOption_cError(!option_c.trim());
    setOption_dError(!option_d.trim());
    setCorrectAnsError(!correct_ans)
    setCorrectSoundError(!correct_ans_sound)
    setWrongSoundError(!wrong_ans_sound)   

    let object = [
        {
            key: question.trim(),
            ref: questionRef.current,
        },
        {
            key: option_a.trim(),
            ref: optionaRef.current,
        },
        {
            key: option_b.trim(),
            ref: optionbRef.current,
        },
        {
            key: option_c.trim(),
            ref: optioncRef.current,
        },
        {
            key: option_d.trim(),
            ref: optiondRef.current,
        },
        
    ];

    for (let i = 0; i < object.length; i++) {
        if (!object[i].key) {
            object[i].ref.focus();
            break;
        }
    }
    error=true;
    }
    if(error){
      return;
    }
    setQuestionError(false)
    setOption_aError(false)
    setOption_bError(false)
    setOption_cError(false)
    setOption_dError(false)
    setCorrectAnsError(false)
    setCorrectSoundError(false)
    setWrongSoundError(false)
    setAssetError(false)
    e.preventDefault();
    const formData = new FormData();
    formData.append('asset', asset); 
    formData.append('game_id', game_id); 
    formData.append('question', question); 
    formData.append('option_a', option_a); 
    formData.append('option_b', option_b); 
    formData.append('option_c', option_c); 
    formData.append('option_d', option_d); 
    formData.append('correct_ans_sound', correct_ans_sound); 
    formData.append('wrong_ans_sound', wrong_ans_sound); 
	  formData.append('correct_ans', correct_ans); 
    formData.append('audio', audio); 
    formData.append('question_id', qusData?.id); 
    setIsloading(true)
    if(type=='CREATE'){
      createGameQuestion(formData).then((Response)=>{
        setIsloading(false)
        if(Response?.status){ 
          close() 
          pageRerender()
          toast.success(Response?.message) 
        }else{
          toast.error(Response?.errorMessage)
        } 
      }) 
    }else{
      updateQuestion(formData).then((Response)=>{
        setIsloading(false)
        if(Response?.status){ 
          close() 
          pageRerender()
          toast.success(Response?.message) 
        }else{
          toast.error(Response?.errorMessage)
        } 
      }) 
    }

  };
 
  
  const handleImageChange = (e) => handleFileValidation(e, setAsset,setAssetError);
  const handleFileChange = (e) => { 
    const file = e.target.files[0];
    if (file && file.type.startsWith('audio/')) {
      setQuestionAudio(file);
      setQuestionAudioError(false) 
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      e.target.value = null
      setPreview(null);
      setQuestionAudio(null); 
    }
  };

  useEffect(() => { 
    if(type=='EDIT'){
      console.log('=================',qusData)
      setQuestion(qusData?.question);
      setOptionA(qusData?.option_a)
      setOptionB(qusData?.option_b)
      setOptionC(qusData?.option_c)
      setOptionD(qusData?.option_d)  
      setCorrectAns(qusData?.correct_ans)
      setCorrectAnsSound(qusData?.correct_ans_sound)
      setWrongAnsSound(qusData?.wrong_ans_sound)
    }
    getAssets().then(res=>{
        if(res?.status){
            setAssetsData(res?.data)
        }
    })
    setShow(isShow)
  }, [isShow]); 
 
  return ( 
    <Modal show={show} onHide={handleClose}  backdrop="static"className="modal-xl">
        <Modal.Header closeButton>
          <h5 className="modal-title">{type=='CREATE'?'Add':'Update'} Question</h5>
        </Modal.Header>
         
        <Modal.Body>
        <form id="createQuestionForm"> 
          <div className="row">
            <div className="form-group  col-md-6  mb10">
                <label htmlFor="questionText" className="mb5 form-label required">Question</label>
                <input  
                value={question}
                maxLength={80}
                ref={questionRef}
                onChange={(e) => {setQuestion(e.target.value)
                    if (questionError && e.target.value.trim() !== '') {
                          setQuestionError(false);
                    }}} 
                type="text" className="form-control" id="questionText" placeholder="Enter the question text" />
                <Form.Control.Feedback type="invalid" style={{ display: questionError ? 'block' : 'none' }}>
                   Question is required
                </Form.Control.Feedback>
            </div>
            <div className="form-group  col-md-6  mb10">
                <label htmlFor="questionAudio" className={`mb5 form-label ${type=='CREATE'?'required':''}`}>Question Audio</label>
                 <input 
                  type="file"  
                  name="asset" 
                  className="form-control" 
                  id="questionAudio"
                  accept="audio/mpeg"
                  onChange={handleFileChange} 
                />
                <Form.Control.Feedback type="invalid" style={{ display: questionAudioError ? 'block' : 'none' }}>
                Question Audio is required
                </Form.Control.Feedback>

                {preview && (
                  <div className="mt-3">
                    <p>Slide Audio Preview:</p>
                    <div className="audio-preview">
                      <audio controls src={preview} controlsList="nodownload"/>
                    </div>
                  </div>
                )}
            </div>
           
                <div className="form-group col-md-6 mb10">
                    <label htmlFor="optionA" className="mb5 form-label required">Option A</label>
                    <input 
                    value={option_a}
                    maxLength={40}
                    ref={optionaRef}  
                    onChange={(e) => {setOptionA(e.target.value)
                    if (option_aError && e.target.value.trim() !== '') {
                          setOption_aError(false);
                    }}}
                    type="text"
                    className="form-control" id="optionA" placeholder="Enter option A" />
                    <Form.Control.Feedback type="invalid" style={{ display: option_aError ? 'block' : 'none' }}>
                   Option A is required and must be less than 40 characters
                </Form.Control.Feedback>
                </div>
                <div className="form-group col-md-6 mb10">
                    <label htmlFor="optionB" className="mb5 form-label required">Option B</label>
                    <input  
                     value={option_b}
                     maxLength={40}
                    ref={optionbRef}
                    onChange={(e) => {setOptionB(e.target.value)
                    if (option_bError && e.target.value.trim() !== '') {
                          setOption_bError(false);
                    }}}  
                    type="text" className="form-control" id="optionB" placeholder="Enter option B" />
                    <Form.Control.Feedback type="invalid" style={{ display: option_bError ? 'block' : 'none' }}>
                   Option B is required and must be less than 40 characters
                </Form.Control.Feedback>
                </div>
                <div className="form-group  col-md-6 mb10">
                    <label htmlFor="optionC" className="mb5 form-label required">Option C</label>
                    <input 
                     value={option_c}
                     maxLength={40}
                    ref={optioncRef}
                    onChange={(e) => {setOptionC(e.target.value)
                    if (option_cError && e.target.value.trim() !== '') {
                          setOption_cError(false);
                    }}}  
                    type="text" className="form-control" id="optionC" placeholder="Enter option C" />
                    <Form.Control.Feedback type="invalid" style={{ display: option_cError ? 'block' : 'none' }}>
                   Option C is required and must be less than 40 characters
                </Form.Control.Feedback>
                 </div>
                 <div className="form-group  col-md-6 mb10">
                <label htmlFor="optionD" className="mb5 form-label required">Option D</label>
                <input 
                 value={option_d}
                 maxLength={40}
                ref={optiondRef}
                onChange={(e) => {setOptionD(e.target.value)
                    if (option_dError && e.target.value.trim() !== '') {
                          setOption_dError(false);
                    }}} 
                type="text" className="form-control" id="optionD" placeholder="Enter option D" />
                <Form.Control.Feedback type="invalid" style={{ display: option_dError ? 'block' : 'none' }}>
                   Option D is required and must be less than 40 characters
                </Form.Control.Feedback>
                </div>
                
                <div className="form-group col-md-6 mb10">
                    <label htmlFor="correctAnswer" className="mb5 form-label required">Correct Answer</label>
                    <select 
                    value={correct_ans}
                    onChange={(e) =>{ setCorrectAns(e.target.value); setCorrectAnsError(false)}} 
                    className="form-control" id="correctAnswer">
                        <option value="">--Select Answer--</option>
                        <option value="a">Option A</option>
                        <option value="b">Option B</option>
                        <option value="c">Option C</option>
                        <option value="d">Option D</option>
                    </select>
                    <Form.Control.Feedback type="invalid" style={{ display: correctAnsError ? 'block' : 'none' }}>
                    Correct Answer is required
                </Form.Control.Feedback>
                </div>
                <div className="form-group col-md-6 mb10">
                    <label htmlFor="correctAnswerSound" className="mb5 form-label required">Correct Answer Sound</label>
                    <select 
                     value={correct_ans_sound}
                    onChange={(e) => {setCorrectAnsSound('');setCorrectAnsSound(e.target.value);setCorrectSoundError(false)}} className="form-control" id="correctAnswerSound">
                        <option value="">--Select Asset--</option>
                        {assetsData.map((obj)=>{
                            return (<>
                             <option key={obj.id} value={obj.id}>{obj.asset_name}</option>
                            </>)
                         })}
                    </select>
                   {correct_ans_sound?<PlaySound assetId={correct_ans_sound} />:''}  
                    <Form.Control.Feedback type="invalid" style={{ display: correctSoundError ? 'block' : 'none' }}>
                    Correct sound is required
                </Form.Control.Feedback>
                </div>
                <div className="form-group col-md-6 mb10">
                    <label htmlFor="wrongAnswerSound" className="mb5 form-label required">Wrong Answer Sound</label>
                    <select 
                     value={wrong_ans_sound}
                    onChange={(e) =>{setWrongAnsSound('');setWrongAnsSound(e.target.value); setWrongSoundError(false)} } className="form-control" id="wrongAnswerSound">
                    <option value="">--Select Asset--</option>
                         {assetsData.map((obj,index)=>{
                            return (<>
                             <option key={obj.id} value={obj.id}>{obj.asset_name}</option>
                            </>)
                         })}
                    </select>  
                    {wrong_ans_sound?<PlaySound assetId={wrong_ans_sound} />:''} 
                    <Form.Control.Feedback type="invalid" style={{ display: wrongSoundError ? 'block' : 'none' }}>
                   Wrong sound is required
                </Form.Control.Feedback>
                </div>
                <div className="form-group col-md-6 mb10">
                    <label htmlFor="qusImage" className={`mb5 form-label ${type=='CREATE'?'required':''}`}>Image</label>
                    <input onChange={handleImageChange} id="qusImage" name="asset" type="file" className="form-control" accept=".png, .jpg, .jpeg" />
                 <Form.Control.Feedback type="invalid" style={{ display: AssetError ? 'block' : 'none' }}>
                    Question Image is required
                </Form.Control.Feedback>
                </div>
            </div> 
           
        </form>
        </Modal.Body>
        <Modal.Footer>
            <button
             disabled={isLoading?true:false}
            type="button"
            id="closesubject"
            className="btn btn-secondary" 
            onClick={()=>handleClose()}
          >
            Close
          </button>
          <button
           disabled={isLoading?true:false}
           onClick={handleSubmit}
            type="button"
            className="btn btn-primary"
          >
            Save
          </button>
        </Modal.Footer>
 
        
      </Modal>
       
  );
};

export default CreateQuestion;